'use client';
export { NextNavigationAdapter as NavigationAdapter } from './NextNavigationAdapter';
